module.exports = __webpack_public_path__ + "static/media/pos.d4eefe2e.svg";